import React from 'react'
import { useTranslation } from 'next-i18next'
import NextHead from 'next/head'
import s from '@ooka_default/components/Maintenance/Maintenance.module.scss'
import cn from 'classnames'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MaintenanceBlock = () => {
    const { t } = useTranslation(['common'])
    return (
        <div>
            <NextHead>
                <title>{t('Maintenence - Site undergoing maintenance')}</title>
            </NextHead>
            <style
                dangerouslySetInnerHTML={{
                    __html:
                        '@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@300&display=swap");body{display: flex;align-items: center;justify-content: center;height: 100vh;padding: 0;margin: 0;text-align: center;}h1{font-size: 52px;line-height: 56px;font-family: "DM Serif Display", serif;font-weight: normal;margin-bottom: 30px;margin-top:40px;}picture svg{margin: auto;}p{font-size: 14px;line-height: 20px;font-family: "Montserrat", sans-serif;}@media only screen and (max-width:767px) {body{padding: 0 15px;}svg{width: 70%;}h1{font-size: 32px;line-height: 36px;}}'
                }}
            />
            <section className={cn(s['maintenance-section'])}>
                <h1 className={cn(s['top-text'])}>
                    {t('Sit back and relax your ')}
                </h1>
                <h1 className={cn(s['bottom-text'])}>
                    {t('is under maintenance.')}
                </h1>
            </section>
        </div>
    )
}
